import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LayersIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M11.6 1.1c.2-.1.6-.1.8 0l10 5a1 1 0 0 1 0 1.8l-10 5a1 1 0 0 1-.8 0l-10-5a1 1 0 0 1 0-1.8l10-5ZM4.2 7l7.8 3.9L19.8 7 12 3.1 4.2 7Z"
      clipRule="evenodd"
    />
    <path d="M1.1 16.6a1 1 0 0 1 1.3-.5L12 21l9.6-4.8a1 1 0 1 1 .8 1.8l-10 5a1 1 0 0 1-.8 0l-10-5a1 1 0 0 1-.5-1.3Z" />
    <path d="M2.4 11.1a1 1 0 1 0-.8 1.8l10 5c.2.1.6.1.8 0l10-5a1 1 0 1 0-.8-1.8L12 16l-9.6-5Z" />
  </Icon>
));
export default LayersIcon;
